import React, { useState,useEffect  } from "react";
import { config } from "../config/config";
import AlumnoForm from "../components/AlumnoForm";
import AlumnoList from "../components/AlumnoList";
import showAlert from '../components/Alert';
import showConfirm from "../components/ConfirmAlert";

const Alumnos = () => {
    const [editingUser, setEditingUser] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);
    const [grados, setGrados] = useState([]);
    const [alumnos, setAlumnos] = useState([]);

    const reloadUserList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    const handleCreateOrUpdate = (usuario) => {
        console.log(usuario);
        const url = editingUser
            ? `${config.apiUrl}/alumnos/${editingUser.alumno_id}`
            : `${config.apiUrl}/alumnos`;
        const method = editingUser ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(usuario),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al guardar la información');
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingUser);
                setEditingUser(null);
                setResetForm(true);
                reloadUserList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/alumnos/${id}`, { method: "DELETE" })
                .then(() => {

                    reloadUserList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    const fetchGrados = () => {
        fetch(`${config.apiUrl}/grados`)
            .then((res) => res.json())
            .then((data) => {

                setGrados(data);
            })
            .catch((error) => console.error("Error al obtener grados:", error));
    };

    const fetchAlumnos = () => {
        fetch(`${config.apiUrl}/alumnos`)
            .then((res) => res.json())
            .then((data) => {

                setAlumnos(data);
            })
            .catch((error) => console.error("Error al obtener alumnos:", error));
    };


    useEffect(() => {
        fetchGrados();
        fetchAlumnos();
    }, []);




    return (
        <div>
            <AlumnoForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingUser}
                usuarios={alumnos}
                grados={grados}
                resetForm={resetForm}
            />

            <AlumnoList
                onEdit={(user) => {
                    // Transformar los datos al formato esperado
                    setEditingUser({
                        usuario_id: user.usuario_id, // Mapear alumno_id a usuario_id
                        alumno_id: user.alumno_id,   // ID del alumno
                        grado_id: user.grado_id || "",
                        ciclo: user.ciclo
                    });
                }}               onDelete={handleDelete}
                reloadTrigger={reloadTrigger}
            />

        </div>
    );
};

export default Alumnos;
